import React from 'react';
import { SECURITY_ACTIONS } from '../../../auth/Security';
import { SIDE_PANEL_IDS } from '../../../constants/constants';
import I18n from '../../../i18n/I18n';
import { Icons } from '../../../icons/Icons';
import type { SidePanelDeclaration, SidePanelDefinition, SidePanelPresetConfiguration } from '../../types';
import { NotesSidePanel } from './NotesSidePanel';
import type { NotesPanelOptions } from './types';

const definition: SidePanelDefinition<'notes'> = {
    id: SIDE_PANEL_IDS.notes,
    kind: 'entity',
    icon: Icons.Notes,
    label: <I18n token="notes.title" />,
    affordancePermission: { securityAction: SECURITY_ACTIONS.COMMENT },
    deepLink: { mode: 'linkedNode', nodeKey: 'note' },
    Component: NotesSidePanel
};

export function notesPanel(
    declarationConfiguration: SidePanelPresetConfiguration<NotesPanelOptions> = {}
): SidePanelDeclaration<'notes'> {
    const declaration: SidePanelDeclaration<'notes'> = {
        definition: { ...definition, ...declarationConfiguration.definition },
        hidden: declarationConfiguration.hidden,
        enabled: declarationConfiguration.enabled,
        options: declarationConfiguration.options
    };
    return declaration;
}
